/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  CircularProgress,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  TextField,
  Typography,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Delete, Edit } from "@mui/icons-material";
import moment from "moment";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { BreadCrumbsContext } from "../../Context/breadCrumbsContext";
import { getData } from "../../Services/getData";
import { postData } from "../../Services/postData";
import { deleteData } from "../../Services/deleteData";
import { LocalUrlEnum, UrlEnum, europeanDate } from "../../Utils/Utils";
import { Vocabulary } from "../../Utils/Vocabulary";
import { breadCrumbsEnum } from "../../Utils/Constants";
import StatusOrder from "../Orders/StatusOrder";
import OrderModal from "../Orders/OrderModal";
import theme from "../../Theme/Theme";

export default function RepairOrders() {
  const breadCrumbsContext = useContext(BreadCrumbsContext);
  const navigate = useNavigate();
  const location = useLocation();
  const notifyError = (msg: string) => toast.error(msg);
  const notifySuccess = (msg: string) => toast.success(msg);

  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [statusEnum, setStatusEnum] = useState<any>([]);
  const [state, setState] = useState<any>({
    orders: [],
    ordersNumber: 0,
    page: 0,
    perPage: 20,
    filter: "Niciun filtru",
    sort: { name: "createdAt", direction: "desc" },
    startDate: moment().subtract(60, "d"),
    endDate: moment(),
    search: null,
  });

  useEffect(() => {
    getData(UrlEnum.orderStatus)
      .then((res) => setStatusEnum(res.data))
      .catch((e) => {
        console.log(e);
      });
  }, []);

  useEffect(() => {
    breadCrumbsContext.setBreadCrumbs([`${breadCrumbsEnum.repairOrders}`]);
    const encodeSearch = decodeURI(location.search);
    const search = encodeSearch.split(/[?&]/);
    const newState = { ...state };
    search.forEach((value) => {
      if (value !== "") {
        const [key, val] = value.split("=");
        if (key === "page") newState[key] = +val - 1;
        else if (key === "sort") {
          const parts = val.split(",");
          newState[key] = { name: parts[0], direction: parts[1] };
        } else if (key === "filter") newState[key] = decodeURIComponent(val);
        else newState[key] = isNaN(+val) ? val : +val;
      }
    });
    getOrders(newState);
  }, [location.search]);

  async function getOrders(s: any) {
    setLoading(true);
    const startDate = moment(s.startDate).format("YYYY-MM-DD");
    const endDate = moment(s.endDate).format("YYYY-MM-DD");
    const sortStr = `${s.sort.name},${s.sort.direction}`;
    let url = `${UrlEnum.repairOrders}/${s.page}/${s.perPage}/${s.filter || "Niciun filtru"}/${sortStr}/${startDate}/${endDate}`;
    if (s.search) url += `/${s.search}`;

    await getData(url)
      .then((res) => {
        setState({
          ...s,
          orders: res.data.orders,
          ordersNumber: res.data.ordersNumber,
        });
      })
      .catch(() => notifyError(Vocabulary.getError))
      .finally(() => setLoading(false));
  }

  function buildUrl(s: any) {
    return `${LocalUrlEnum.repairOrders}?page=${s.page + 1}?perPage=${s.perPage}?filter=${s.filter}?sort=${s.sort.name},${s.sort.direction}?startDate=${moment(s.startDate).format("YYYY-MM-DD")}?endDate=${moment(s.endDate).format("YYYY-MM-DD")}`;
  }

  function handleChangeStatus(
    _id: string | null | undefined,
    value: string | undefined
  ) {
    const newState = { ...state, filter: value, page: 0 };
    navigate(`${buildUrl(newState)}`);
  }

  async function handleAddNew() {
    setLoading(true);
    postData(UrlEnum.repairOrders, {})
      .then((res) => navigate(`${LocalUrlEnum.repairOrders}${res.data._id}`))
      .catch(() => notifyError(Vocabulary.addError))
      .finally(() => setLoading(false));
  }

  async function handleDelete() {
    if (!deleteId) return;
    setLoading(true);
    deleteData(`${UrlEnum.repairOrders}/${deleteId}`)
      .then(async () => {
        notifySuccess(Vocabulary.deleteSuccess);
        await getOrders(state);
      })
      .catch(() => notifyError(Vocabulary.deleteError))
      .finally(() => {
        setLoading(false);
        setOpenDeleteModal(false);
        setDeleteId(null);
      });
  }

  const columns = [
    {
      label: Vocabulary.numberOrder,
      name: "orderNumber",
      options: {
        sort: true,
        customBodyRender: (_: any, tableMeta: any) => (
          <Typography
            style={{ cursor: "pointer", fontWeight: state.orders[tableMeta.rowIndex]?.isNew ? "bold" : "normal" }}
            onClick={() => navigate(`${LocalUrlEnum.repairOrders}${state.orders[tableMeta.rowIndex]._id}`)}
          >
            {state.orders[tableMeta.rowIndex]?.orderNumber}
          </Typography>
        ),
      },
    },
    {
      label: Vocabulary.clientName,
      name: "clientInfo",
      options: {
        sort: false,
        customBodyRender: (_: any, tableMeta: any) => {
          const order = state.orders[tableMeta.rowIndex];
          return (
            <Typography
              style={{ cursor: "pointer", fontWeight: order?.isNew ? "bold" : "normal" }}
              onClick={() => navigate(`${LocalUrlEnum.repairOrders}${order._id}`)}
            >
              {order?.clientInfo?.name || "—"}
            </Typography>
          );
        },
      },
    },
    {
      label: Vocabulary.email,
      name: "clientInfo",
      options: {
        sort: false,
        customBodyRender: (_: any, tableMeta: any) => {
          const order = state.orders[tableMeta.rowIndex];
          return (
            <Typography
              style={{ cursor: "pointer", fontWeight: order?.isNew ? "bold" : "normal" }}
              onClick={() => navigate(`${LocalUrlEnum.repairOrders}${order._id}`)}
            >
              {order?.clientInfo?.email || "—"}
            </Typography>
          );
        },
      },
    },
    {
      label: Vocabulary.phone,
      name: "clientInfo",
      options: {
        sort: false,
        customBodyRender: (_: any, tableMeta: any) => {
          const order = state.orders[tableMeta.rowIndex];
          return (
            <Typography
              style={{ cursor: "pointer", fontWeight: order?.isNew ? "bold" : "normal" }}
              onClick={() => navigate(`${LocalUrlEnum.repairOrders}${order._id}`)}
            >
              {order?.clientInfo?.phoneNumber || "—"}
            </Typography>
          );
        },
      },
    },
    {
      label: Vocabulary.deviceName,
      name: "repair",
      options: {
        sort: false,
        customBodyRender: (_: any, tableMeta: any) => {
          const order = state.orders[tableMeta.rowIndex];
          return (
            <Typography
              style={{ cursor: "pointer", fontWeight: order?.isNew ? "bold" : "normal" }}
              onClick={() => navigate(`${LocalUrlEnum.repairOrders}${order._id}`)}
            >
              {order?.repair?.deviceName || "—"}
            </Typography>
          );
        },
      },
    },
    {
      label: Vocabulary.repairName,
      name: "repair",
      options: {
        sort: false,
        customBodyRender: (_: any, tableMeta: any) => {
          const order = state.orders[tableMeta.rowIndex];
          return (
            <Typography
              style={{ cursor: "pointer", fontWeight: order?.isNew ? "bold" : "normal" }}
              onClick={() => navigate(`${LocalUrlEnum.repairOrders}${order._id}`)}
            >
              {order?.repair?.repairName || "—"}
            </Typography>
          );
        },
      },
    },
    {
      label: Vocabulary.totalRepairPrice,
      name: "repair",
      options: {
        sort: false,
        customBodyRender: (_: any, tableMeta: any) => {
          const order = state.orders[tableMeta.rowIndex];
          return (
            <Typography
              style={{ cursor: "pointer", fontWeight: order?.isNew ? "bold" : "normal" }}
              onClick={() => navigate(`${LocalUrlEnum.repairOrders}${order._id}`)}
            >
              {order?.repair?.totalPrice != null ? `${order.repair.totalPrice} RON` : "—"}
            </Typography>
          );
        },
      },
    },
    {
      label: Vocabulary.status,
      name: "status",
      options: {
        sort: true,
        customBodyRender: (_: any, tableMeta: any) => {
          const order = state.orders[tableMeta.rowIndex];
          return (
            <Typography
              style={{ cursor: "pointer", fontWeight: order?.isNew ? "bold" : "normal" }}
              onClick={() => navigate(`${LocalUrlEnum.repairOrders}${order._id}`)}
            >
              {order?.status?.order || "—"}
            </Typography>
          );
        },
      },
    },
    {
      label: Vocabulary.date,
      name: "createdAt",
      options: {
        sort: true,
        customBodyRender: (value: any, tableMeta: any) => {
          const order = state.orders[tableMeta.rowIndex];
          return (
            <Typography
              style={{ cursor: "pointer", fontWeight: order?.isNew ? "bold" : "normal" }}
              onClick={() => navigate(`${LocalUrlEnum.repairOrders}${order._id}`)}
            >
              {moment(value).format("DD-MM-YYYY HH:mm")}
            </Typography>
          );
        },
      },
    },
    {
      label: Vocabulary.options.toUpperCase(),
      name: "options",
      options: {
        setCellHeaderProps: () => ({ align: "center" as any }),
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (dataIndex: number) => (
          <div style={{ marginTop: -10, marginBottom: -10 }}>
            <ToggleButtonGroup exclusive>
              <Tooltip title={Vocabulary.edit}>
                <ToggleButton
                  value="edit"
                  onClick={() =>
                    navigate(`${LocalUrlEnum.repairOrders}${state.orders[dataIndex]._id}`)
                  }
                >
                  <Edit />
                </ToggleButton>
              </Tooltip>
              <Tooltip title={Vocabulary.delete}>
                <ToggleButton
                  value="delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeleteId(state.orders[dataIndex]._id);
                    setOpenDeleteModal(true);
                  }}
                >
                  <Delete />
                </ToggleButton>
              </Tooltip>
            </ToggleButtonGroup>
          </div>
        ),
      },
    },
  ];

  function getTableOptions() {
    return {
      selectableRows: "none" as any,
      viewColumns: false as any,
      responsive: "simple" as any,
      rowsPerPageOptions: [10, 20, 50, 100],
      filter: false,
      print: false,
      download: false,
      textLabels: { body: { noMatch: Vocabulary.noResultsFound } },
      count: state.ordersNumber,
      rowsPerPage: state.perPage,
      page: state.page,
      search: true,
      serverSide: true,
      sortOrder: { name: state.sort.name, direction: state.sort.direction } as any,
      setRowProps: (_: any, __: any, rowIndex: number) => {
        const order = state.orders[rowIndex];
        const st = statusEnum.find(
          (s: any) => s.name?.toLowerCase() === order?.status?.order?.toLowerCase()
        );
        return {
          style: {
            backgroundColor: st?.color || theme.palette.grayColor?.main,
            cursor: "pointer",
          },
        };
      },
      onRowClick: (_: any, rowMeta: any) =>
        navigate(`${LocalUrlEnum.repairOrders}${state.orders[rowMeta.rowIndex]._id}`),
      onChangePage: (page: number) =>
        navigate(`${buildUrl({ ...state, page })}`),
      onChangeRowsPerPage: (perPage: number) =>
        navigate(`${buildUrl({ ...state, page: 0, perPage })}`),
      onSearchChange: (search: string | null) => {
        if (search && search.length > 2)
          navigate(`${buildUrl({ ...state, page: 0 })}?search=${search}`);
        else if (!search)
          navigate(`${buildUrl({ ...state, page: 0 })}`);
      },
      onSearchClose: () => navigate(`${buildUrl({ ...state, page: 0 })}`),
      onColumnSortChange: (col: string, dir: string) =>
        navigate(`${buildUrl({ ...state, sort: { name: col, direction: dir } })}`),
    };
  }

  return (
    <>
      <Grid container spacing={2} style={{ marginBottom: 12 }}>
        <Grid item xs={12} md={12} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button variant="contained" color="primary" onClick={handleAddNew}>
            {Vocabulary.newRepairOrder}
          </Button>
        </Grid>
        <Grid item xs={12} md={3}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DesktopDatePicker
              label={Vocabulary.startDate}
              value={state.startDate}
              maxDate={state.endDate}
              inputFormat={europeanDate}
              onChange={(val: any) => {
                if (val && val.isValid())
                  navigate(`${buildUrl({ ...state, startDate: val, page: 0 })}`);
              }}
              renderInput={(params) => <TextField {...params} size="small" fullWidth />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={3}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DesktopDatePicker
              label={Vocabulary.endDate}
              value={state.endDate}
              minDate={state.startDate}
              inputFormat={europeanDate}
              onChange={(val: any) => {
                if (val && val.isValid())
                  navigate(`${buildUrl({ ...state, endDate: val, page: 0 })}`);
              }}
              renderInput={(params) => <TextField {...params} size="small" fullWidth />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={6}>
          <StatusOrder
            isOrder={false}
            status={state.filter}
            handleChangeStatus={handleChangeStatus}
            name="applyFilters"
            noFilter={{ name: "Niciun filtru", color: theme.palette.primary?.main }}
            statusType="repair"
          />
        </Grid>
      </Grid>

      <MUIDataTable
        title={Vocabulary.repairOrders}
        data={state.orders}
        columns={columns}
        options={getTableOptions()}
      />

      {openDeleteModal && (
        <OrderModal
          title={Vocabulary.deleteRepairOrder}
          openModal={openDeleteModal}
          closeModal={() => setOpenDeleteModal(false)}
          handleModifyValues={handleDelete}
        />
      )}

      {loading && (
        <div className="loading">
          <CircularProgress color="primary" />
        </div>
      )}
    </>
  );
}
